import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AdminAccessService {

  constructor(private fs: AngularFirestore) { }

  accessTrue: boolean = false
  
  accessId: string = ''

  sendAccess(access:boolean) {
    this.fs.collection('admins').add({
      access
    })
  }

  getAccess() {
    return this.fs.collection('admins').snapshotChanges()
  }

}
